<template>
    <div class="hidden print:block mb-4">
        <div class="px-2 pb-3 border-b-1 border-gray-800">
            <!-- Title -->
            <div class="flex items-baseline gap-2">
                <div class="leading-tight">
                    <div class="text-[18px] font-extrabold tracking-wide text-gray-900">
                        HE<span class="text-red-600">ART</span> CLINIC
                    </div>
                    <div class="text-[12px] text-gray-700 italic"
                        style="font-family: 'Lucida Calligraphy','Lucida Sans',serif;">
                        ARTA DE A VINDECA
                    </div>
                </div>
            </div>

            <!-- Contact -->
            <div class="mt-2 text-[11px] text-gray-800 space-y-1">
                <div class="flex items-start gap-2">
                    <i class="pi pi-map-marker mt-[2px] text-[11px] text-gray-700"></i>
                    <span>Șos. Ștefan cel Mare și Sfânt, nr. 4, bloc A11, Iași</span>
                </div>

                <div class="flex items-start gap-2">
                    <i class="pi pi-phone mt-[2px] text-[11px] text-gray-700"></i>
                    <span>
                        Telefon programări: <span class="font-semibold">0743 292 292</span>
                    </span>
                </div>

                <div class="flex items-start gap-2">
                    <i class="pi pi-envelope mt-[2px] text-[11px] text-gray-700"></i>
                    <span>
                        Email: <span class="font-semibold">heartclinic.iasi@gmail.com</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
